import { render, staticRenderFns } from "./TrainerModal.vue?vue&type=template&id=79c41f8c&"
import script from "./TrainerModal.vue?vue&type=script&lang=js&"
export * from "./TrainerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports